import { writable } from 'svelte/store';

export const formData = writable({
  id: '',
  name: '',
  date: '',
  time: '',
  location: '',
  isSet: false,
  isInitiated: false,
  reset: false,
});